import axios from 'axios'
import MetodosGlobais from '@/utils/MetodosGlobais'
import constantes from '@/utils/ConstantesGlobais'
import {router} from '../router/index'

var global_isRefreshing = false
var refresher_promise = null

const api = axios.create({
  baseURL: window.location.hostname.includes(constantes.DOMINIO_INTERNO) ? constantes.URL_INTERNA_BASE+"/api/v1" : constantes.URL_EXTERNA_BASE+"/api/v1",
  withCredentials: false,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use(function (config) {
  const store = require('@/store').default
  if (!store.state.loading.isAutoUpdate) {
    store.commit('loading/startLoading')
  }
  if (store.state.authentication.user) {
    const token = store.state.authentication.user.token ? store.state.authentication.user.token : false
    if (token) {
      config.headers.Authorization = MetodosGlobais.montarToken(token)
    }
  }
  return config
}, function (err) {
  const store = require('@/store').default
  store.commit('loading/endAutoUpdateLoading')
  return Promise.reject(err)
})

api.interceptors.response.use(function (response) {
  const store = require('@/store').default
  if (!store.state.loading.isAutoUpdate) { store.commit('loading/endLoading') }
  store.commit('loading/endAutoUpdateLoading')
  return response
}, function (err) {
  const store = require('@/store').default
  store.commit('loading/endAutoUpdateLoading')
  // Axios não usa status para erros genéricos de rede, então, se tiver status, tem resposta do servidor
  if (err.response) {
    let response = err.response
    /* Se for uma resposta de não autorização e tiver uma cabeçalho, tenta fazer o refresh */
    if (response.status === 401 && response.config.headers.Authorization) {
      if (global_isRefreshing) {
        return new Promise((resolve, reject) => {
          refresher_promise.then((response) => {
            store.commit('loading/endLoading')
            if (response.status != '200') {
              return reject(err.response)
            } else {
              return resolve(api(err.response.config))
            }
          })
        })
      }
      global_isRefreshing = true
      refresher_promise = store.dispatch('authentication/refresh')
      return refresher_promise
        .then(response => {
          store.commit('loading/endLoading')
          /* Se o refresh não tiver êxito, redireciona para a tela de login */
          if (response.status != '200') {
            store.commit('loading/forceEndLoading')
            store.dispatch('authentication/logout')
            let redirect = ''
            if (router.currentRoute.path !== '/') { redirect = router.currentRoute.path } else {
              redirect = window.location.href.replace(window.location.origin, '')
              redirect = redirect === '/' || redirect === '/auth/login' ? '' : redirect
            }
            router.push({ path: '/auth/login',
              query: {
                error: 'auth.session_expired',
                redirect: redirect,
              } })
            global_isRefreshing = false
            return Promise.reject(err.response)
          } else {
            /* Se tiver êxito, pega as configurações da resposta que obteve sucesso e gera uma nova requisição
                            e retorna */
            global_isRefreshing = false
            return api(err.response.config)
          }
        })
    } else {
      global_isRefreshing = false
      store.commit('loading/endLoading')
      return Promise.reject(err.response)
    }
  } else {
    global_isRefreshing = false
    store.commit('loading/forceEndLoading')
    router.push('/error/connection-error')
    return Promise.reject(new Error(err.message))
  }
})

export default api
